import React from 'react'
import Sidebar from '../component/Sidebar'
import Header from '../component/Header'
import ChatMessageInput from '../component/ChatMessageInput'
import { useLocation } from 'react-router-dom'

export default function PrivateUserLayout({ children }) {                                             

    const location = useLocation();
    const routeBackgrounds = {
        '/story': '#FFE6D9',
        '/blogs': '#FFF7C1',
        '/press': '#E5EDFF',
    };

    const backgroundColor = routeBackgrounds[location.pathname] || 'default-bg-color';
    
    var screenheight=window.innerHeight;
    // var screenheight=732
    if(screenheight>=890 && screenheight<1000){
        var h1=parseInt(screenheight-((screenheight*20)/100))
    }
    if(screenheight<800 && screenheight>=700){
        var h1=parseInt(screenheight-((screenheight*30)/100))
    }
    if(screenheight>=800 && screenheight<890){
        var h1=parseInt(screenheight-((screenheight*30)/100))
    }
    return (
        <div className='flex h-screen'>

            <Sidebar />

            <div className='content--area w-full relative h-full'>
                <Header />
                <div className='h-[calc(100vh-122px)] relative px-5' >
                    {children}
                </div>
                {/* {location.pathname !== '/' && <ChatMessageInput backgroundColor={backgroundColor} />} */}
            </div>
        </div>
    )
}


